/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 7/1/22
 */
import ContentSkeleton from '@/modules/auditorAudits/components/WrapperRunAudit/components/ManageAuditContent/ContentSkeleton';
import Bookmarks from '@/modules/auditorAudits/components/WrapperRunAudit/components/ManageAuditContent/components/Bookmarks';
import { createBookmarkContents } from '@/modules/auditorAudits/components/WrapperRunAudit/components/ManageAuditContent/components/Bookmarks/useBookmarkContext';
import { useAuditData } from '@/modules/auditorAudits/hooks/useAuditData';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import ResponseList from './components/ResponseList';
import {useSelectAuditView} from '@/modules/auditorAudits/hooks/useSelectAuditView';

const ManageAuditContent = ({ isLoading }) => {
  const { goToSection } = useSelectAuditView();
  const { dataIntro, dataSections, dataContacts } = useAuditData();

  const contents = useMemo(() => (
    createBookmarkContents(dataIntro, dataSections, dataContacts)
  ), [dataIntro, dataSections, dataContacts]);

  if (isLoading) return <ContentSkeleton className='md:px-16' />;

  return (
    <Bookmarks contents={ contents } onSelectedChange={ goToSection } hideIncidences scrollInTable>
      <ResponseList />
    </Bookmarks>
  );
};

ManageAuditContent.propTypes = {
  currentAudit: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default memo(ManageAuditContent);

